<template>
  <div class="direct-order-switch d-flex" v-if="this.$store.state.smartLogisticSettings.directOrderAllowed">
    <div class="mr-4">
      <span class="label" :class="{'text-primary':directOrder}">Sofortbestellung</span>
    </div>
    <div>
      <v-switch
          v-model="directOrder"
          class="mt-0 pt-0"
          dense small light flat inset
          hide-details="auto"
          label=""></v-switch>
    </div>

  </div>

</template>

<script>
export default {
  name: 'DirectOrderSwtich',
  computed: {
    directOrder: {
      get() {
        return this.$store.state.smartLogisticSettings.directOrder
      },
      set(value) {
        this.$store.commit('smartLogisticSettings/setDirectOrder', !!value)
      }
    }
  }

}

</script>
